import React from "react";
import {
    Alignment,
    FlexBehaviour,
    Side,
    Size,
} from "../../types/system/Layout";
import Utilities from "../../foundation/Utility";

import "./Error.scss";

interface ErrorProps {
    children?: any;
    inline?: boolean;
    flexBehaviour?: FlexBehaviour;
    className?: string;
    wrappable?: boolean;

    clearanceSide?: Side;
    clearanceSize?: Size;

    bufferSide?: Side;
    bufferSize?: Size;

    alignment?: Alignment;
}

class Error extends React.Component<ErrorProps> {
    render(): React.ReactNode {
        let classNames = this.props.className ? ` ${this.props.className}` : "";

        // Clearance classes
        if (!!this.props.clearanceSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.clearanceSide,
            )}clearance${Utilities.getSizeClass(this.props.clearanceSize)}`;
        }

        // Buffer classes
        if (!!this.props.bufferSide) {
            classNames += ` ${Utilities.getSideClass(
                this.props.bufferSide,
            )}buffer${Utilities.getSizeClass(this.props.bufferSize)}`;
        }

        switch (this.props.flexBehaviour) {
            case "min":
                classNames += " col-pane";
                break;
            case "max":
                classNames += " col";
                break;
            case "center":
                classNames += " center-pane";
                break;
        }

        // Alignment classes
        if (!!this.props.alignment) {
            classNames += ` text-${this.props.alignment}`;
        }

        if (this.props.inline) classNames += " inline";
        if (this.props.wrappable) classNames += " wrappable";

        return (
            <div className={`error-container${classNames}`}>{this.props.children}</div>
        );
    }
}

export default Error;
